
import { defineComponent } from 'vue';
import { computed } from '@vue/runtime-core';
import { Actions, Getters, userSettingsStore } from '@/store';
import { useStore } from 'vuex';

import ModalHeader from '@/modules/modals/components/ModalHeader.vue';
import ModalBody from '@/modules/modals/components/ModalBody.vue';
import ModalFooter from '@/modules/modals/components/ModalFooter.vue';
import ModalService from '@/modules/modals/services/modalService';
import utils from '@/utils/QSUtils';
import UserSettingsManager from '@/manager/UserSettingsManager';

export default defineComponent({
    components: { ModalHeader, ModalBody, ModalFooter },
    data() {
        return {
            modal: null,
        };
    },
    setup() {
        const store = useStore();

        const computedSubjectCascadeDisabled = computed(() => UserSettingsManager.isSubjectCascadeDisabled());
        const subjectCascadeDisabled = computedSubjectCascadeDisabled.value;

        return {
            store,
            subjectCascadeDisabled,
        };
    },
    mounted() {
        const modalElement = this.$refs.subjectRunDataPreferences;
        this.modal = ModalService.initialize(modalElement, this);
        ModalService.size(modalElement, '');
        ModalService.open(this.modal);
    },
    methods: {
        async save() {
            const subjectCascadeDisabled = document.querySelector('input[name="cascadeLock"]:checked') as HTMLInputElement;

            userSettingsStore.setSubjectCascadeDisabled({
                SubjectCascadeDisabled: utils.stringToBoolean(subjectCascadeDisabled.value)
            });

            ModalService.hide(this.modal);
        },
    },
});
